import React, { useState, useEffect } from 'react';
import './JobForm.css';
import axios from 'axios';
import { toast } from 'react-toastify';
import { getAuth } from 'firebase/auth';
import { useNavigate, useParams } from 'react-router-dom';
import TextareaAutosize from 'react-textarea-autosize';
import imageCompression from 'browser-image-compression';

const JobForm = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const isEditMode = !!id;
const [imageUploading, setImageUploading] = useState(false);
const [uploadedImageUrl, setUploadedImageUrl] = useState('');
const [pdfFile, setPdfFile] = useState(null);
const [pdfUploading, setPdfUploading] = useState(false);
const [showCategories, setShowCategories] = useState(false);

  const [formData, setFormData] = useState({
    jobHeading: '',
    email: '',
    company: '',
    jobDetails: '', 
    contactNumber: '',
    countryCode: '+91',
    customCountryCode: '',
     location: '', // ✅ add this
     categories: [], // for multi-select
pdfUrl: ''      // for manual link

    // Now holds [{ details: "" }]
  });

  const [image, setImage] = useState(null);
  const [job, setJob] = useState(null);




  useEffect(() => {
    if (isEditMode) {
      const fetchJob = async () => {
        try {
          const res = await axios.get(`${process.env.REACT_APP_API_URL}/api/jobs/${id}`);
          setJob(res.data);
        } catch (err) {
          console.error('Failed to fetch job', err);
        }
      };
      fetchJob();
    }
  }, [id, isEditMode]);

  useEffect(() => {
  if (job) {
    const phone = job.contact || '';
    const match = phone.match(/^(\+\d+)(\d{10})$/);
  // List of your predefined categories
    const predefinedCategories = [
      "IT", "Civil Engineering", "Electrical Engineering", "Mechanical Engineering",
      "Healthcare", "Education", "Government", "Sales & Marketing",
      "Accounting & Finance", "Automobile", "Airlines, Avaition",
      "Banking", "Computer Operator", "Content Writer", "Customer Support",
      "Counselling", "Graphic Designer", "HR", "Internship/Apprenticeship",
      "JKPSC Jobs", "JKSSB Jobs", "Law", "Management", "Kashmir University Jobs",
      "Office Staff", "Security", "Digital Marketting", "SKIMS", "SKUAST",
      "Travel/Tourism", "Other"
    ];

  // Predefined categories list


// Start with whatever is saved
let loadedCategories = job.categories || [];
let customCategoryText = "";

// If any category is NOT in predefined list → treat as custom category
const nonPredefined = loadedCategories.find(
  cat => !predefinedCategories.includes(cat)
);
if (nonPredefined) {
  customCategoryText = nonPredefined;

  // Ensure "Other" is selected in UI if a custom category exists
  if (!loadedCategories.includes("Other")) {
    loadedCategories.push("Other");
  }

  // Remove actual custom text from the categories array for UI
  loadedCategories = loadedCategories.filter(cat => cat !== nonPredefined);
}

setFormData({
  jobHeading: job.jobHeading || '',
  email: job.email || '',
  company: job.company || '',
  jobDetails: job.jobDetails || '',
  contactNumber: match ? match[2] : '',
  countryCode: match ? match[1] : '+91',
  customCountryCode: '',
  location: job.location || '',
  categories: loadedCategories,
  customCategory: customCategoryText,
  pdfUrl: job.pdfUrl || '',
  imagePublicId: job.imagePublicId || null
});

  }
}, [job]);


  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
const handleImageChange = async (e) => {
  const file = e.target.files[0];
  if (!file) return;

  console.log("📂 Original size:", (file.size / 1024).toFixed(2), "KB");

  setImageUploading(true);

  try {
    // Compression options
    const options = {
      maxSizeMB: 0.2, // Target 200 KB
      maxWidthOrHeight: 1024, // Resize large images to max 1024px
      useWebWorker: true
    };

    // Compress the file
    const compressedFile = await imageCompression(file, options);

    console.log("✅ Compressed size:", (compressedFile.size / 1024).toFixed(2), "KB");

    // Upload compressed file to Cloudinary
    const formData = new FormData();
    formData.append('file', compressedFile);
formData.append('upload_preset', 'job_post_images'); 
formData.append('folder', 'job-portal/jobs'); // 📂 use your existing folder
formData.append('cloud_name', 'dv6xb7swc');


    const res = await fetch('https://api.cloudinary.com/v1_1/dv6xb7swc/image/upload', {
      method: 'POST',
      body: formData,
    });

    const data = await res.json();

    // Save Cloudinary URL & public ID
    setUploadedImageUrl(data.secure_url);
    setFormData((prev) => ({
      ...prev,
      imagePublicId: data.public_id
    }));

    setImage(compressedFile); // Local preview

  } catch (err) {
    console.error('❌ Image upload failed:', err);
  } finally {
    setImageUploading(false);
  }
};

 
 const isFormValid =
  formData.jobHeading.trim() !== '' &&
  formData.jobDetails.trim() !== '';
const handlePdfUpload = async () => {
  if (!pdfFile) return '';

  setPdfUploading(true);

  const fd = new FormData();
  fd.append('file', pdfFile);
  fd.append('upload_preset', 'job_post_images'); // your preset
  fd.append('cloud_name', 'dv6xb7swc');
  fd.append('folder', 'job-portal/jobs');
  fd.append('resource_type', 'raw'); // ✅ important

  try {
    const res = await fetch(
      'https://api.cloudinary.com/v1_1/dv6xb7swc/raw/upload', // ✅ correct endpoint for PDFs
      { method: 'POST', body: fd }
    );

    const data = await res.json();
    console.log('📄 PDF Upload Result:', data);

    if (data.secure_url) {
      setFormData(prev => ({
        ...prev,
        pdfUrl: data.secure_url,
        pdfPublicId: data.public_id
      }));
      return data.secure_url;
    } else {
      throw new Error('PDF upload failed');
    }
  } catch (err) {
    console.error('❌ PDF upload failed:', err);
    toast.error('Failed to upload PDF');
    return '';
  } finally {
    setPdfUploading(false);
  }
};


  const handleSubmit = async (e) => {
  e.preventDefault();
  const auth = getAuth();
  const user = auth.currentUser;
  const token = user ? await user.getIdToken() : '';

  const selectedCode =
    formData.countryCode === 'custom'
      ? formData.customCountryCode
      : formData.countryCode;

  if (!selectedCode.startsWith('+')) {
    alert('Country code must start with +');
    return;
  }

  const fullContact = `${selectedCode}${formData.contactNumber}`;
let finalPdfUrl = formData.pdfUrl?.trim(); // Manual link if provided

// If no manual link and user uploaded file → upload to Cloudinary
if (!finalPdfUrl && pdfFile) {
  const uploadedPdfUrl = await handlePdfUpload();
  if (uploadedPdfUrl) finalPdfUrl = uploadedPdfUrl;
}

// ✅ Fix for custom category handling
let finalCategories = formData.categories ? [...formData.categories] : [];

// ✅ If "Other" is selected with a custom category → replace "Other" with the custom text
// ✅ If "Other" is selected with a custom category → replace it and keep others intact
if (finalCategories.includes("Other")) {
  if (formData.customCategory?.trim()) {
    finalCategories = finalCategories.map(cat =>
      cat === "Other" ? formData.customCategory.trim() : cat
    );
  } else {
    // If no custom text provided, remove "Other"
    finalCategories = finalCategories.filter(cat => cat !== "Other");
  }
}


// ✅ Remove accidental duplicates & trim extra spaces
finalCategories = [...new Set(finalCategories.map(cat => cat.trim()))];




  const jobObject = {
    jobHeading: formData.jobHeading,
    location: formData.location,
    email: formData.email,
    company: formData.company,
    jobDetails: formData.jobDetails,
   ...(formData.contactNumber && {
    contact: `${selectedCode}${formData.contactNumber}`,
  }),
   imageUrl: uploadedImageUrl || job?.imageUrl || '',
imagePublicId: formData.imagePublicId || job?.imagePublicId || null,

  categories: finalCategories, // ✅ fixed here
 pdfUrl: finalPdfUrl || job?.pdfUrl || '',
// ✅ now always correct
  pdfPublicId: formData.pdfPublicId || null              // ✅ PDF link or uploaded file
  };

  try {
   
    if (isEditMode) {
      // UPDATE existing job
      await axios.put(
        `${process.env.REACT_APP_API_URL}/api/jobs/edit/${id}`,
        jobObject,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      toast.success('✅ Job updated successfully!', { autoClose: 2000 });


      navigate('/admin');
    } else {
      // CREATE new job
      const form = new FormData();
      form.append('jobs', JSON.stringify([jobObject]));

      await axios.post(`${process.env.REACT_APP_API_URL}/api/jobs/create`, form, {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'multipart/form-data',
        },
      });

    

      const msg = encodeURIComponent(
        `Hi, I have submitted a job through your portal. Please check the dashboard or reach out if you need more details.`
      );

      const whatsappURL = `https://wa.me/918494056223?text=${msg}`;
      localStorage.setItem('jobSubmitted', 'true');
      localStorage.setItem('whatsappURL', whatsappURL);
      navigate('/job-success', { state: { whatsappURL } });
    }
  } catch (err) {
    console.error('❌ Job submit failed:', err);
    toast.error('❌ Failed to submit job. Please try again.');
  }
};



  return (
    <div className="job-form-container">
      <div className="text-center">
        <h2>{isEditMode ? 'Edit Job' : 'Submit a Job'}</h2>
      </div>

     <form onSubmit={handleSubmit}>
  {/* 1. Job Heading */}
  <div className="form-field">
    <label>
      Job Heading <span className="required-asterisk">*</span>
    </label>
    <input type="text" name="jobHeading" value={formData.jobHeading} onChange={handleChange} required />
  </div>
  {/* 2. Description */}
  <div className="form-field">
   <label>Job Details <span className="required-asterisk">*</span></label>
<TextareaAutosize
  name="jobDetails"
  placeholder="Enter full job details (qualifications, experience, salary, etc.)"
  value={formData.jobDetails}
  onChange={handleChange}
  minRows={5}
  className="form-control"
/>

  </div>
  

  {/* 3. Email */}
  <div className="form-field">
    <label>Email</label>
    <input type="email" name="email" value={formData.email} onChange={handleChange} />
  </div>

  {/* 4. Company */}
  <div className="form-field">
    <label>Company Name</label>
    <input type="text" name="company" value={formData.company} onChange={handleChange} />
  </div>

  {/* 5. Contact */}
  <div className="form-field">
    <label>Contact Number (optional)</label>
    <div style={{ display: 'flex', gap: '10px' }}>
      <select name="countryCode" value={formData.countryCode} onChange={handleChange}>
        <option value="+91">+91 (India)</option>
        <option value="custom">Custom</option>
      </select>

      {formData.countryCode === 'custom' && (
        <input
          type="text"
          name="customCountryCode"
          placeholder="+___"
          value={formData.customCountryCode}
          onChange={handleChange}
          required
        />
      )}

    <input
  type="tel"
  name="contactNumber"
  value={formData.contactNumber}
  onChange={handleChange}
  pattern="[0-9]{10}"
  maxLength={10}
  placeholder="Enter 10-digit number (optional)"
/>
    </div>
  </div>
{/* ✅ Job Categories - Pill style in two columns */}
<div className="form-field">
  <label>
    Job Categories <span className="required-asterisk">*</span>
  </label>
  <div className="tag-multiselect two-columns">
    {[
      "IT", "Civil Engineering", "Electrical Engineering", "Mechanical Engineering",
      "Healthcare", "Education", "Government", "Sales & Marketing",
      "Accounting & Finance", "Automobile", "Airlines, Avaition",
      "Banking", "Computer Operator", "Content Writer", "Customer Support",
      "Counselling", "Graphic Designer", "HR", "Internship/Apprenticeship",
      "JKPSC Jobs", "JKSSB Jobs", "Law", "Management", "Kashmir University Jobs",
      "Office Staff", "Security", "Digital Marketting", "SKIMS", "SKUAST",
      "Travel/Tourism", "Other"
    ].map((cat) => (
      <span
        key={cat}
        className={`tag-option ${formData.categories.includes(cat) ? "selected" : ""}`}
        onClick={() => {
          setFormData((prev) => {
            const isSelected = prev.categories.includes(cat);
            return {
              ...prev,
              categories: isSelected
                ? prev.categories.filter((c) => c !== cat)
                : [...prev.categories, cat]
            };
          });
        }}
      >
        {cat}
      </span>
    ))}
  </div>

  {formData.categories.includes("Other") && (
    <input
      type="text"
      placeholder="Enter custom category"
      value={formData.customCategory || ""}
      onChange={(e) =>
        setFormData((prev) => ({
          ...prev,
          customCategory: e.target.value
        }))
      }
      style={{ marginTop: "10px", width: "100%" }}
    />
  )}
</div>




  {/* ✅ 7. Location */}
  <div className="form-field">
    <label>
      Location <span className="required-asterisk">*</span>
    </label>
    <input
      type="text"
      name="location"
      placeholder="Enter Job Location (e.g., Srinagar, Bangalore)"
      value={formData.location}
      onChange={handleChange}
      required
    />
  </div>



  {/* 8. Upload Poster */}
  <div className="form-field">
    <label>{isEditMode ? 'Change Poster (optional)' : 'Upload Job Poster'}</label>
    <input type="file" accept="image/*" onChange={handleImageChange} />

  </div>

{imageUploading ? (
  <p style={{ color: 'blue' }}>Uploading image...</p>
) : uploadedImageUrl ? (
  <div>
    <img src={uploadedImageUrl} alt="Uploaded Preview" className="preview-image" />
  </div>
) : image ? (
  <div>
    <img src={URL.createObjectURL(image)} alt="Preview" className="preview-image" />
  </div>
) : null}


  {!image && isEditMode && job?.imageUrl && (
    <div>
      <img src={job.imageUrl.replace('/upload/', '/upload/w_400,h_300,c_fill/')} alt="Existing Poster" className="preview-image" />
      <p>Current Poster</p>
    </div>
  )}
{/* PDF Upload */}
<div className="form-field">
  <label>Upload Job PDF (optional)</label>
  <input
    type="file"
    accept="application/pdf"
    onChange={(e) => setPdfFile(e.target.files[0])}
  />
  {pdfFile && <p>Selected: {pdfFile.name}</p>}
</div>

{/* PDF Link */}
<div className="form-field">
  <label>Or paste PDF link</label>
  <input
    type="url"
    placeholder="https://example.com/job.pdf"
    value={formData.pdfUrl}
    onChange={(e) => setFormData({ ...formData, pdfUrl: e.target.value })}
  />
</div>

  {/* 9. Submit */}
  <button
  type="submit"
  disabled={!isFormValid || imageUploading || pdfUploading}
  className="submit-btn"
>
  {imageUploading || pdfUploading ? 'Uploading...' : isEditMode ? 'Update Job' : 'Submit Job'}
</button>

</form>

    </div>
  );
};

export default JobForm;
